module.exports = __webpack_public_path__ + "static/media/four.38fb2fd2.svg";